import React, { ReactElement } from 'react';

export default function ErrorPageSVG(): ReactElement | null {
  return (
    <svg width="367" height="278" viewBox="0 0 367 278" fill="none">
      <circle cx="5" cy="112" r="5" fill="#DBDDE1" />
      <circle cx="279" cy="194" r="6" fill="#DBDDE1" />
      <circle cx="256" cy="274" r="4" fill="#DBDDE1" />
      <rect
        x="272.223"
        y="7.42383"
        width="7"
        height="28"
        rx="3.5"
        transform="rotate(45 272.223 7.42383)"
        fill="#DBDDE1"
      />
      <rect
        x="252.424"
        y="12.375"
        width="7"
        height="28"
        rx="3.5"
        transform="rotate(-45 252.424 12.375)"
        fill="#DBDDE1"
      />
      <rect x="34.625" width="7.75" height="31" rx="3.875" fill="#DBDDE1" />
      <rect
        x="23"
        y="19.375"
        width="7.75"
        height="31"
        rx="3.875"
        transform="rotate(-90 23 19.375)"
        fill="#DBDDE1"
      />
      <rect x="36" y="183" width="6" height="24" rx="3" fill="#DBDDE1" />
      <rect
        x="27"
        y="198"
        width="6"
        height="24"
        rx="3"
        transform="rotate(-90 27 198)"
        fill="#DBDDE1"
      />
      <circle cx="336.5" cy="201.5" r="27.5" fill="#FDD3D3" />
      <path
        d="M199 258C218.5 243.5 232.5 223.5 272.5 233.5C312.5 243.5 323.5 226.5 331 213"
        stroke="#888D9B"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="path-12-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M347.851 189.636C348.6 189.99 348.919 190.885 348.564 191.633L345.782 197.508L348.493 198.792C349.491 199.265 349.917 200.457 349.444 201.456L346.019 208.685C345.976 208.777 345.927 208.864 345.872 208.945C345.786 209.161 345.692 209.376 345.591 209.589C342.99 215.079 336.431 217.422 330.941 214.821C325.451 212.22 323.108 205.661 325.709 200.171C325.81 199.958 325.917 199.749 326.03 199.546C326.058 199.452 326.094 199.359 326.137 199.267L329.562 192.037C330.035 191.039 331.228 190.613 332.226 191.086L334.937 192.37L337.72 186.496C338.074 185.747 338.969 185.428 339.717 185.783C340.466 186.137 340.786 187.032 340.431 187.78L337.648 193.655L340.359 194.939L343.071 196.223L345.853 190.349C346.208 189.6 347.102 189.281 347.851 189.636Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M347.851 189.636C348.6 189.99 348.919 190.885 348.564 191.633L345.782 197.508L348.493 198.792C349.491 199.265 349.917 200.457 349.444 201.456L346.019 208.685C345.976 208.777 345.927 208.864 345.872 208.945C345.786 209.161 345.692 209.376 345.591 209.589C342.99 215.079 336.431 217.422 330.941 214.821C325.451 212.22 323.108 205.661 325.709 200.171C325.81 199.958 325.917 199.749 326.03 199.546C326.058 199.452 326.094 199.359 326.137 199.267L329.562 192.037C330.035 191.039 331.228 190.613 332.226 191.086L334.937 192.37L337.72 186.496C338.074 185.747 338.969 185.428 339.717 185.783C340.466 186.137 340.786 187.032 340.431 187.78L337.648 193.655L340.359 194.939L343.071 196.223L345.853 190.349C346.208 189.6 347.102 189.281 347.851 189.636Z"
        fill="white"
      />
      <path
        d="M348.564 191.633L345.853 190.349L348.564 191.633ZM345.782 197.508L343.071 196.223L341.786 198.935L344.497 200.219L345.782 197.508ZM349.444 201.456L352.155 202.74L349.444 201.456ZM346.019 208.685L343.308 207.401L346.019 208.685ZM345.872 208.945L343.38 207.275L343.203 207.539L343.085 207.834L345.872 208.945ZM326.03 199.546L328.655 200.998L328.809 200.72L328.901 200.416L326.03 199.546ZM332.226 191.086L330.942 193.797L332.226 191.086ZM334.937 192.37L333.653 195.082L336.364 196.366L337.648 193.655L334.937 192.37ZM337.72 186.496L340.431 187.78L340.431 187.78L337.72 186.496ZM340.431 187.78L343.142 189.065L343.142 189.065L340.431 187.78ZM337.648 193.655L334.937 192.37L333.653 195.082L336.364 196.366L337.648 193.655ZM340.359 194.939L339.075 197.65L340.359 194.939ZM343.071 196.223L341.786 198.935L344.497 200.219L345.782 197.508L343.071 196.223ZM351.276 192.918C352.34 190.672 351.381 187.988 349.135 186.924L346.567 192.347C345.818 191.992 345.499 191.098 345.853 190.349L351.276 192.918ZM348.493 198.792L351.276 192.918L345.853 190.349L343.071 196.223L348.493 198.792ZM349.777 196.081L347.066 194.796L344.497 200.219L347.209 201.503L349.777 196.081ZM352.155 202.74C353.338 200.244 352.273 197.263 349.777 196.081L347.209 201.503C346.71 201.267 346.497 200.67 346.733 200.171L352.155 202.74ZM348.731 209.97L352.155 202.74L346.733 200.171L343.308 207.401L348.731 209.97ZM348.364 210.616C348.501 210.412 348.623 210.196 348.731 209.97L343.308 207.401C343.329 207.358 343.353 207.316 343.38 207.275L348.364 210.616ZM348.302 210.874C348.43 210.603 348.549 210.331 348.658 210.057L343.085 207.834C343.022 207.992 342.954 208.149 342.88 208.305L348.302 210.874ZM329.657 217.532C336.644 220.842 344.992 217.861 348.302 210.874L342.88 208.305C340.989 212.298 336.218 214.001 332.225 212.11L329.657 217.532ZM322.998 198.887C319.688 205.874 322.669 214.222 329.657 217.532L332.225 212.11C328.232 210.218 326.529 205.448 328.42 201.455L322.998 198.887ZM323.405 198.094C323.262 198.352 323.126 198.616 322.998 198.887L328.42 201.455C328.494 201.299 328.573 201.147 328.655 200.998L323.405 198.094ZM323.426 197.983C323.319 198.209 323.23 198.441 323.159 198.676L328.901 200.416C328.886 200.463 328.869 200.508 328.849 200.551L323.426 197.983ZM326.851 190.753L323.426 197.983L328.849 200.551L332.273 193.322L326.851 190.753ZM333.51 188.375C331.015 187.193 328.033 188.257 326.851 190.753L332.273 193.322C332.037 193.821 331.441 194.034 330.942 193.797L333.51 188.375ZM336.221 189.659L333.51 188.375L330.942 193.797L333.653 195.082L336.221 189.659ZM337.648 193.655L340.431 187.78L335.009 185.212L332.226 191.086L337.648 193.655ZM340.431 187.78C340.076 188.529 339.182 188.849 338.433 188.494L341.002 183.072C338.756 182.008 336.073 182.966 335.009 185.212L340.431 187.78ZM338.433 188.494C337.684 188.139 337.365 187.245 337.72 186.496L343.142 189.065C344.206 186.819 343.248 184.135 341.002 183.072L338.433 188.494ZM337.72 186.496L334.937 192.37L340.359 194.939L343.142 189.065L337.72 186.496ZM341.644 192.228L338.933 190.943L336.364 196.366L339.075 197.65L341.644 192.228ZM344.355 193.512L341.644 192.228L339.075 197.65L341.786 198.935L344.355 193.512ZM343.142 189.065L340.359 194.939L345.782 197.508L348.564 191.633L343.142 189.065ZM349.135 186.924C346.889 185.861 344.206 186.819 343.142 189.065L348.564 191.633C348.21 192.382 347.315 192.701 346.567 192.347L349.135 186.924Z"
        fill="#888D9B"
        mask="url(#path-12-inside-1)"
      />
      <rect
        x="68.5602"
        y="78.6797"
        width="161.286"
        height="31.5865"
        fill="#C0C2C9"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="68.5602"
        y="78.6797"
        width="143.128"
        height="31.5865"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="68.5599"
        y="135.748"
        width="161.286"
        height="31.5865"
        fill="#C0C2C9"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="68.5599"
        y="135.748"
        width="143.128"
        height="31.5865"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="68.5599"
        y="197.139"
        width="161.286"
        height="31.5865"
        fill="#C0C2C9"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="68.5599"
        y="197.139"
        width="143.128"
        height="31.5865"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="61.6426"
        y="41.5"
        width="177.714"
        height="50.609"
        rx="8.5"
        fill="#C0C2C9"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="61.6426"
        y="41.5"
        width="156.098"
        height="50.609"
        rx="8.5"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="86.312"
        y="56.6582"
        width="20.2932"
        height="20.2932"
        rx="6.5"
        fill="#FDD3D3"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="93.407"
        y="63.3457"
        width="9.20659"
        height="0.575412"
        rx="0.287706"
        transform="rotate(45 93.407 63.3457)"
        fill="#F74040"
        stroke="#F74040"
        strokeWidth="2"
      />
      <rect
        x="99.9172"
        y="63.752"
        width="9.20659"
        height="0.575412"
        rx="0.287706"
        transform="rotate(135 99.9172 63.752)"
        fill="#F74040"
        stroke="#F74040"
        strokeWidth="2"
      />
      <line
        x1="127.726"
        y1="76.8445"
        x2="137.31"
        y2="56.2902"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="140.695"
        y1="76.8445"
        x2="150.28"
        y2="56.2902"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="153.665"
        y1="76.8445"
        x2="163.25"
        y2="56.2902"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="166.635"
        y1="76.8445"
        x2="176.22"
        y2="56.2902"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="179.605"
        y1="76.8445"
        x2="189.19"
        y2="56.2902"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="61.6429"
        y="100.297"
        width="177.714"
        height="50.609"
        rx="8.5"
        fill="#C0C2C9"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="61.6429"
        y="100.297"
        width="156.098"
        height="50.609"
        rx="8.5"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="86.3124"
        y="115.455"
        width="20.2932"
        height="20.2932"
        rx="6.5"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <line
        x1="127.726"
        y1="135.641"
        x2="137.311"
        y2="115.087"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="140.696"
        y1="135.641"
        x2="150.28"
        y2="115.087"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="153.666"
        y1="135.641"
        x2="163.25"
        y2="115.087"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="166.636"
        y1="135.641"
        x2="176.22"
        y2="115.087"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="179.606"
        y1="135.641"
        x2="189.19"
        y2="115.087"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="61.6429"
        y="159.094"
        width="177.714"
        height="50.609"
        rx="8.5"
        fill="#C0C2C9"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="61.6429"
        y="159.094"
        width="156.098"
        height="50.609"
        rx="8.5"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="86.3124"
        y="174.252"
        width="20.2932"
        height="20.2932"
        rx="6.5"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <line
        x1="127.726"
        y1="194.438"
        x2="137.311"
        y2="173.884"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="140.696"
        y1="194.438"
        x2="150.28"
        y2="173.884"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="153.666"
        y1="194.438"
        x2="163.25"
        y2="173.884"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="166.636"
        y1="194.438"
        x2="176.22"
        y2="173.884"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="179.606"
        y1="194.438"
        x2="189.19"
        y2="173.884"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="61.6429"
        y="217.891"
        width="177.714"
        height="50.609"
        rx="8.5"
        fill="#C0C2C9"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="61.6429"
        y="217.891"
        width="156.098"
        height="50.609"
        rx="8.5"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <rect
        x="86.3124"
        y="233.049"
        width="20.2932"
        height="20.2932"
        rx="6.5"
        fill="white"
        stroke="#A4A8B2"
        strokeWidth="3"
      />
      <line
        x1="127.726"
        y1="253.235"
        x2="137.311"
        y2="232.681"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="140.696"
        y1="253.235"
        x2="150.28"
        y2="232.681"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="153.666"
        y1="253.235"
        x2="163.25"
        y2="232.681"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="166.636"
        y1="253.235"
        x2="176.22"
        y2="232.681"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="179.606"
        y1="253.235"
        x2="189.19"
        y2="232.681"
        stroke="#A4A8B2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1.44231"
          height="2.61728"
        >
          <use transform="scale(0.00320513 0.00411523)" />
        </pattern>
        <image id="image0" width="450" height="636" />
      </defs>
    </svg>
  );
}
